import { ActiveOfferContent } from '@/server/services/vendor/models';

export const sortOffers = (offers: ActiveOfferContent[]): ActiveOfferContent[] => {
    return [...offers].sort((a, b) => {
        const aAvailable = a.availableQuantity > 0;
        const bAvailable = b.availableQuantity > 0;

        if (!!a.isBuyBoxWinner !== !!b.isBuyBoxWinner) return a.isBuyBoxWinner ? -1 : 1;
        if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;

        const aPrice = a.sellingPrice ?? a.price;
        const bPrice = b.sellingPrice ?? b.price;
        return aPrice - bPrice;
    });
};
